// extracted by mini-css-extract-plugin
export default {"modalHeader":"Kaa-z","modalContent":"Laa-z","formWrapper":"Maa-z","fade":"Naa-z","fade-in":"Oaa-z"};